import PropTypes from "prop-types";
import { Box, FormControl, Grid, InputAdornment, MenuItem, OutlinedInput, Select } from "@mui/material";
import { useTranslation } from "react-i18next";
import { languages } from "../../../localisation/HeaderFormJSON";
import { useEffect, useState } from "react";
import { getLivisLanguage, getLivistheme } from "../../../helpers/storage";
import { setupLivisThemeSync } from "../../../helpers/utils";

// import * "../../../assets/image/icons/lincode_livis.svg"


const getIndustryName = () => {
    try {
        const hostname = window.location.hostname;
        if (hostname.includes("automotive")) return "Automotive";
        if (hostname.includes("aerospace")) return "Aerospace";
        if (hostname.includes("electronics")) return "Electronics";
        if (hostname.includes("semi")) return "Semiconductor";
    } catch (error) {
        console.log("Error loading ")
     }
    return ""; 
};

const AuthHeader = (props: any = null) => {
    const industryName = getIndustryName();
    const { t, i18n } = useTranslation();
    const logo = props.livis_logo ? props.livis_logo : process.env.PUBLIC_URL + '/image/icons/lincode_livis.svg';
    const globe_icon = process.env.PUBLIC_URL + '/image/icons/globe.svg';


    const [selectedLanguage, setSelectedLanguage] = useState('')
    const [selectedIcon, setSelectedIcon] = useState(globe_icon);
    const [selectedTheme, setSelectedTheme] = useState("light");

    const demo_url = props.lincode_demo_url ? props.lincode_demo_url : "https://www.lincode.ai/contact";
    const livis_logo_dark = process.env.PUBLIC_URL + '/image/icons/lincode_logo_dark.svg';
    const [livisLogo, setLivisLogo] = useState(logo);
    const [theme, setTheme] = useState<string>(getLivistheme());



    useEffect(() => {
        const currentLanguage = getLivisLanguage()
        console.log(currentLanguage)
        if (currentLanguage) {
            const language = languages.find((item: any) => item?.store === currentLanguage)
            if (language && language?.label) {
                const lng_img = process.env.PUBLIC_URL + language.icon;
                setSelectedIcon(lng_img)
                console.log(language)
                setSelectedLanguage(language?.label)
                i18n.changeLanguage(language?.store)
            }
        }

        const currentTheme = getLivistheme();
        setSelectedTheme(currentTheme);
        // document.body.className = `livis-${currentTheme}-theme`;
    }, [i18n])


    const handleLanguageChange = (e: any) => {
        setSelectedLanguage(e.target.value)
        console.log(e.target.value)
        const language = languages.find((item: any) => item?.label === e.target.value)
        if (language && language?.store) {
            console.log(language)
            localStorage.setItem("livis_lang", language?.store)
            i18n.changeLanguage(language?.store)
            // window.location.reload()
        }

        const selectedValue = e.target.value;
        const selectedItem = languages.find((item: any) => item.label === selectedValue);

        if (selectedItem) {
            const lng_img = process.env.PUBLIC_URL + selectedItem.icon;
            setSelectedIcon(lng_img);
        } else {
            setSelectedIcon(globe_icon);
        }
    }

    useEffect(() => {
        if (theme === "dark") {
            setLivisLogo(livis_logo_dark)
        } else {
            setLivisLogo(logo)
        }
    }, [theme])

    useEffect(() => {
        document.body.className = `livis-${theme}-theme`;
    }, [theme]);

    useEffect(() => {
        return setupLivisThemeSync(setTheme);
    }, [])


    return (
        <>
            <Box className="livis-auth-header">
                <Grid container spacing={2} className="livis-auth-header-container livis-auth-header-grid">
                    <Grid item lg={9} md={9} sm={9} xs={9} display="flex" alignItems="center">
                        <div className="livis-auth-header-logo-wrap" style={{ display: 'flex', alignItems: 'center' }}>
                            <img src={livisLogo} alt="livis logo" />
                            {industryName && (
                                <span 
                                    className="industry-name-text"
                                    style={{
                                    marginLeft: '12px',
                                    borderLeft: '2px solid #999',
                                    paddingLeft: '12px',
                                    fontSize: '2rem',
                                    fontWeight: 600,
                                    color: theme === 'dark' ? '#fff' : '#333'
                                }}>
                                    {t(industryName)}
                                </span>
                            )}
                        </div>
                    </Grid>

                    <Grid item lg={3} md={3} sm={3} xs={3} className="livis-auth-header-right-container" display={"flex"} justifyContent={"flex-end"} alignItems={"center"}>

                        {/* <Box className="livis-landing-header-theme-select-container">
                            <Select
                                value={selectedTheme}
                                onChange={(e) => {
                                    const newTheme = e.target.value;
                                    setSelectedTheme(newTheme);
                                    document.body.className = `livis-${newTheme}-theme`;
                                    localStorage.setItem("livis_theme", newTheme);
                                }}
                                displayEmpty
                                inputProps={{ 'aria-label': 'Without label' }}
                                renderValue={(selected) => {
                                    if (selected === '') {
                                        return <span>{t("Select Theme")}</span>;
                                    }
                                    return (
                                        <div className="livis-header-select-theme-container">
                                            {selected === "light" ? t("Light Mode") : t("Dark Mode")}
                                        </div>
                                    );
                                }}
                            >
                                <MenuItem value="light" className="livis-header-select-theme">
                                    {t("Light Mode")}
                                </MenuItem>
                                <MenuItem value="dark" className="livis-header-select-theme">
                                    {t("Dark Mode")}
                                </MenuItem>
                            </Select>
                        </Box> */}
                        <Box className="livis-landing-header-language-select-container">
                            <FormControl>
                                <Select
                                    // disabled
                                    value={selectedLanguage}
                                    onChange={handleLanguageChange}
                                    displayEmpty
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    renderValue={(selected) => {
                                        if (!selected) {
                                            return <span>{t("Select Language")}</span>;
                                        }
                                        const selectedItem = languages.find((item) => item.label === selected);
                                        return (
                                            <div className="livis-header-lang-picker-align-center">
                                                <img className="livis-header-lang-img" src={selectedIcon} alt="" />
                                                {selectedItem?.label}
                                            </div>
                                        );
                                    }}
                                >
                                    {
                                        languages?.map((item: any, index: any) => {
                                            const lng_img = process.env.PUBLIC_URL + item?.icon
                                            return (
                                                <MenuItem value={item?.label} key={`lng-${index}`}>
                                                    <img src={lng_img} alt={item?.language} className="livis-header-lang-img" />
                                                    {item?.language}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                        </Box>
                        <div className="livis-auth-header-demo-wrap">
                            <a data-testid="demo-button" href={demo_url} target="_blank" className="livis-request-demo-btn" rel="noreferrer">
                                <span className="demo-text-hide">{t('Request a Demo')}</span>
                                <span className="livis-demo-text-show">{t('Demo')}</span>
                            </a>
                        </div>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
};
export default AuthHeader;